<form [formGroup]="schoolFileForm" *ngIf="schoolFiles">
    <div formArrayName="fileDetails">
        <p-table [value]="schoolFiles.controls">
            <ng-template pTemplate="header">
                <tr>
                    <th>Name</th>
                    <th>
                        Type
                    </th>
                    <th>
                        Should be completed by student
                    </th>
                    <th>Comment</th>
                    <th>Delete</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-fileFormGroup>
                <tr [formGroup]="fileFormGroup">
                    <td>
                        <a style="cursor: pointer;"
                            (click)="downloadFile(fileFormGroup)">{{fileFormGroup.value.name}}</a>
                    </td>
                    <td>
                        <p-dropdown appendTo="body" placeholder="Select Type" [options]="fileTypes" optionLabel="name" formControlName="fileType"></p-dropdown>
                    </td>
                    <td>
                        <p-checkbox [binary]="true" formControlName="needsToBeCompleted"></p-checkbox>
                    </td>
                    <td>
                        <input pInputText formControlName="comment">
                    </td>
                    <td>
                        <p-button styleClass="p-button-danger" (onClick)="deleteFile(fileFormGroup)" icon="pi pi-trash"></p-button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</form>

<p-fileUpload #fileUploadRef [multiple]="true" [customUpload]="true" (uploadHandler)="uploadFiles($event)" [disabled]="schoolService.selectedSchool.isDeleted">
</p-fileUpload>